/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as SessionRouteImport } from './routes/session'
import { Route as RuntimeClaimRouteImport } from './routes/runtime-claim'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as DevicesRouteImport } from './routes/devices'
import { Route as BrowserGateRouteImport } from './routes/browser-gate'
import { Route as ConsoleRouteImport } from './routes/_console'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthDeviceResultRouteImport } from './routes/auth.device-result'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as ConsoleOverviewRouteImport } from './routes/_console.overview'
import { Route as ConsoleAccountRouteImport } from './routes/_console.account'
import { Route as ConsoleWorkIndexRouteImport } from './routes/_console.work.index'
import { Route as ConsoleRuntimesIndexRouteImport } from './routes/_console.runtimes.index'
import { Route as ConsoleHelpIndexRouteImport } from './routes/_console.help.index'
import { Route as ConsoleWorkIdRouteImport } from './routes/_console.work.$id'
import { Route as ConsoleRuntimesIdRouteImport } from './routes/_console.runtimes.$id'
import { Route as ConsoleHelpSlugRouteImport } from './routes/_console.help.$slug'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionRoute = SessionRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => rootRouteImport,
} as any)
const RuntimeClaimRoute = RuntimeClaimRouteImport.update({
  id: '/runtime-claim',
  path: '/runtime-claim',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesRoute = DevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => rootRouteImport,
} as any)
const BrowserGateRoute = BrowserGateRouteImport.update({
  id: '/browser-gate',
  path: '/browser-gate',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleRoute = ConsoleRouteImport.update({
  id: '/_console',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDeviceResultRoute = AuthDeviceResultRouteImport.update({
  id: '/auth/device-result',
  path: '/auth/device-result',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleOverviewRoute = ConsoleOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleAccountRoute = ConsoleAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleWorkIndexRoute = ConsoleWorkIndexRouteImport.update({
  id: '/work/',
  path: '/work/',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleRuntimesIndexRoute = ConsoleRuntimesIndexRouteImport.update({
  id: '/runtimes/',
  path: '/runtimes/',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleHelpIndexRoute = ConsoleHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleWorkIdRoute = ConsoleWorkIdRouteImport.update({
  id: '/work/$id',
  path: '/work/$id',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleRuntimesIdRoute = ConsoleRuntimesIdRouteImport.update({
  id: '/runtimes/$id',
  path: '/runtimes/$id',
  getParentRoute: () => ConsoleRoute,
} as any)
const ConsoleHelpSlugRoute = ConsoleHelpSlugRouteImport.update({
  id: '/help/$slug',
  path: '/help/$slug',
  getParentRoute: () => ConsoleRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/browser-gate': typeof BrowserGateRoute
  '/devices': typeof DevicesRoute
  '/legal': typeof LegalRoute
  '/login': typeof LoginRoute
  '/runtime-claim': typeof RuntimeClaimRoute
  '/session': typeof SessionRoute
  '/sessions': typeof SessionsRoute
  '/support': typeof SupportRoute
  '/account': typeof ConsoleAccountRoute
  '/overview': typeof ConsoleOverviewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/device-result': typeof AuthDeviceResultRoute
  '/help/$slug': typeof ConsoleHelpSlugRoute
  '/runtimes/$id': typeof ConsoleRuntimesIdRoute
  '/work/$id': typeof ConsoleWorkIdRoute
  '/help/': typeof ConsoleHelpIndexRoute
  '/runtimes/': typeof ConsoleRuntimesIndexRoute
  '/work/': typeof ConsoleWorkIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/browser-gate': typeof BrowserGateRoute
  '/devices': typeof DevicesRoute
  '/legal': typeof LegalRoute
  '/login': typeof LoginRoute
  '/runtime-claim': typeof RuntimeClaimRoute
  '/session': typeof SessionRoute
  '/sessions': typeof SessionsRoute
  '/support': typeof SupportRoute
  '/account': typeof ConsoleAccountRoute
  '/overview': typeof ConsoleOverviewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/device-result': typeof AuthDeviceResultRoute
  '/help/$slug': typeof ConsoleHelpSlugRoute
  '/runtimes/$id': typeof ConsoleRuntimesIdRoute
  '/work/$id': typeof ConsoleWorkIdRoute
  '/help': typeof ConsoleHelpIndexRoute
  '/runtimes': typeof ConsoleRuntimesIndexRoute
  '/work': typeof ConsoleWorkIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_console': typeof ConsoleRouteWithChildren
  '/browser-gate': typeof BrowserGateRoute
  '/devices': typeof DevicesRoute
  '/legal': typeof LegalRoute
  '/login': typeof LoginRoute
  '/runtime-claim': typeof RuntimeClaimRoute
  '/session': typeof SessionRoute
  '/sessions': typeof SessionsRoute
  '/support': typeof SupportRoute
  '/_console/account': typeof ConsoleAccountRoute
  '/_console/overview': typeof ConsoleOverviewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/device-result': typeof AuthDeviceResultRoute
  '/_console/help/$slug': typeof ConsoleHelpSlugRoute
  '/_console/runtimes/$id': typeof ConsoleRuntimesIdRoute
  '/_console/work/$id': typeof ConsoleWorkIdRoute
  '/_console/help/': typeof ConsoleHelpIndexRoute
  '/_console/runtimes/': typeof ConsoleRuntimesIndexRoute
  '/_console/work/': typeof ConsoleWorkIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/browser-gate'
    | '/devices'
    | '/legal'
    | '/login'
    | '/runtime-claim'
    | '/session'
    | '/sessions'
    | '/support'
    | '/account'
    | '/overview'
    | '/auth/callback'
    | '/auth/device-result'
    | '/help/$slug'
    | '/runtimes/$id'
    | '/work/$id'
    | '/help/'
    | '/runtimes/'
    | '/work/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/browser-gate'
    | '/devices'
    | '/legal'
    | '/login'
    | '/runtime-claim'
    | '/session'
    | '/sessions'
    | '/support'
    | '/account'
    | '/overview'
    | '/auth/callback'
    | '/auth/device-result'
    | '/help/$slug'
    | '/runtimes/$id'
    | '/work/$id'
    | '/help'
    | '/runtimes'
    | '/work'
  id:
    | '__root__'
    | '/'
    | '/_console'
    | '/browser-gate'
    | '/devices'
    | '/legal'
    | '/login'
    | '/runtime-claim'
    | '/session'
    | '/sessions'
    | '/support'
    | '/_console/account'
    | '/_console/overview'
    | '/auth/callback'
    | '/auth/device-result'
    | '/_console/help/$slug'
    | '/_console/runtimes/$id'
    | '/_console/work/$id'
    | '/_console/help/'
    | '/_console/runtimes/'
    | '/_console/work/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConsoleRoute: typeof ConsoleRouteWithChildren
  BrowserGateRoute: typeof BrowserGateRoute
  DevicesRoute: typeof DevicesRoute
  LegalRoute: typeof LegalRoute
  LoginRoute: typeof LoginRoute
  RuntimeClaimRoute: typeof RuntimeClaimRoute
  SessionRoute: typeof SessionRoute
  SessionsRoute: typeof SessionsRoute
  SupportRoute: typeof SupportRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthDeviceResultRoute: typeof AuthDeviceResultRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session': {
      id: '/session'
      path: '/session'
      fullPath: '/session'
      preLoaderRoute: typeof SessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runtime-claim': {
      id: '/runtime-claim'
      path: '/runtime-claim'
      fullPath: '/runtime-claim'
      preLoaderRoute: typeof RuntimeClaimRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices': {
      id: '/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browser-gate': {
      id: '/browser-gate'
      path: '/browser-gate'
      fullPath: '/browser-gate'
      preLoaderRoute: typeof BrowserGateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console': {
      id: '/_console'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ConsoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/device-result': {
      id: '/auth/device-result'
      path: '/auth/device-result'
      fullPath: '/auth/device-result'
      preLoaderRoute: typeof AuthDeviceResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_console/overview': {
      id: '/_console/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof ConsoleOverviewRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/account': {
      id: '/_console/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ConsoleAccountRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/work/': {
      id: '/_console/work/'
      path: '/work'
      fullPath: '/work/'
      preLoaderRoute: typeof ConsoleWorkIndexRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/runtimes/': {
      id: '/_console/runtimes/'
      path: '/runtimes'
      fullPath: '/runtimes/'
      preLoaderRoute: typeof ConsoleRuntimesIndexRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/help/': {
      id: '/_console/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof ConsoleHelpIndexRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/work/$id': {
      id: '/_console/work/$id'
      path: '/work/$id'
      fullPath: '/work/$id'
      preLoaderRoute: typeof ConsoleWorkIdRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/runtimes/$id': {
      id: '/_console/runtimes/$id'
      path: '/runtimes/$id'
      fullPath: '/runtimes/$id'
      preLoaderRoute: typeof ConsoleRuntimesIdRouteImport
      parentRoute: typeof ConsoleRoute
    }
    '/_console/help/$slug': {
      id: '/_console/help/$slug'
      path: '/help/$slug'
      fullPath: '/help/$slug'
      preLoaderRoute: typeof ConsoleHelpSlugRouteImport
      parentRoute: typeof ConsoleRoute
    }
  }
}

interface ConsoleRouteChildren {
  ConsoleAccountRoute: typeof ConsoleAccountRoute
  ConsoleOverviewRoute: typeof ConsoleOverviewRoute
  ConsoleHelpSlugRoute: typeof ConsoleHelpSlugRoute
  ConsoleRuntimesIdRoute: typeof ConsoleRuntimesIdRoute
  ConsoleWorkIdRoute: typeof ConsoleWorkIdRoute
  ConsoleHelpIndexRoute: typeof ConsoleHelpIndexRoute
  ConsoleRuntimesIndexRoute: typeof ConsoleRuntimesIndexRoute
  ConsoleWorkIndexRoute: typeof ConsoleWorkIndexRoute
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleAccountRoute: ConsoleAccountRoute,
  ConsoleOverviewRoute: ConsoleOverviewRoute,
  ConsoleHelpSlugRoute: ConsoleHelpSlugRoute,
  ConsoleRuntimesIdRoute: ConsoleRuntimesIdRoute,
  ConsoleWorkIdRoute: ConsoleWorkIdRoute,
  ConsoleHelpIndexRoute: ConsoleHelpIndexRoute,
  ConsoleRuntimesIndexRoute: ConsoleRuntimesIndexRoute,
  ConsoleWorkIndexRoute: ConsoleWorkIndexRoute,
}

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConsoleRoute: ConsoleRouteWithChildren,
  BrowserGateRoute: BrowserGateRoute,
  DevicesRoute: DevicesRoute,
  LegalRoute: LegalRoute,
  LoginRoute: LoginRoute,
  RuntimeClaimRoute: RuntimeClaimRoute,
  SessionRoute: SessionRoute,
  SessionsRoute: SessionsRoute,
  SupportRoute: SupportRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthDeviceResultRoute: AuthDeviceResultRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
